export const REKAPITULACE = "REKAPITULACE";
export const ROKY = "ROKY";
export const DETAIL_SPORU = "DETAIL_SPORU";
export const TYPSPORU = "TYP_SPROU";
export const DRUHSPORU = "DRUH_SPORU";
export const ORGJEDNOTKA = "ORG_JEDNOTKA";
export const STAVSPORU = "STAV_SPORU";
export const SOUDY = "SOUDY";
export const VYSLEDKYSPORU = "VYSLEDKY_SPORU";
export const INSTANCESOUDU = "INSTANCE_SOUDU";
